(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hzw-grid-with-swiper"] && !Shopify.designMode) return;
  try {
    
  const button = document.getElementById('yg-custom-button-join-us');
  if (button) {
    button.addEventListener('click', (event) => {
      const smileUI = window.SmileUI;
      if (smileUI && typeof smileUI.openPanel === 'function') {
        smileUI.openPanel(button);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hzw-tab-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hzw-pill-tabs')) {
  customElements.define('hzw-pill-tabs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('.hzw-pill-tab')];
      this.panels = [...this.querySelectorAll('.hzw-pill-panel')];
      this.viewport = this.querySelector('.hzw-pill-viewport');
      this.shell = this.querySelector('.hzw-pill-shell');
      this.list = this.querySelector('.hzw-pill-list');
      this.prev = this.querySelector('.hzw-pill-prev');
      this.next = this.querySelector('.hzw-pill-next');
      this.shell.hidden = !this.tabs.length;
      this.active = -1;
      this.activate(0, false);
      requestAnimationFrame(() => { if (this.isConnected) this.setAttribute("data-ready", ""); });
      this.addEventListener('click', event => {
        const tab = event.target.closest('.hzw-pill-tab');
        if (this.tabs.includes(tab)) this.activate(this.tabs.indexOf(tab), true);
      }, options);
      this.prev.addEventListener('click', () => this.selectAdjacent(-1), options);
      this.next.addEventListener('click', () => this.selectAdjacent(1), options);
      this.viewport.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
      this.list.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next = index;
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus({ preventScroll: true });
        this.activate(next, true);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.tabs.findIndex(tab => tab.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.activate(index, true);
      }, options);
      this.resize?.disconnect();
      this.resize = new ResizeObserver(() => {
        this.updateIndicator();
        this.updateArrows();
        this.reveal(this.tabs[this.active], false);
      });
      this.resize.observe(this.viewport);
      this.resize.observe(this.list);
      this.updateArrows();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.animations?.forEach(animation => animation.cancel()); }
    updateIndicator() {
      const tab = this.tabs[this.active];
      if (!tab) return;
      this.list.style.setProperty('--hzw-active-left', `${tab.offsetLeft}px`);
      this.list.style.setProperty('--hzw-active-width', `${tab.offsetWidth}px`);
    }
    behavior(smooth) { return smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'; }
    updateArrows() {
      const overflowing = this.viewport.scrollWidth > this.viewport.clientWidth + 1;
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const leftIndex = this.active + (rtl ? 1 : -1);
      const rightIndex = this.active + (rtl ? -1 : 1);
      this.prev.setAttribute('aria-label', rtl ? 'Next tab' : 'Previous tab');
      this.next.setAttribute('aria-label', rtl ? 'Previous tab' : 'Next tab');
      [[this.prev, leftIndex], [this.next, rightIndex]].forEach(([button, index]) => {
        const enabled = overflowing && index >= 0 && index < this.tabs.length;
        button.setAttribute('aria-disabled', String(!enabled));
        button.tabIndex = enabled ? 0 : -1;
      });
    }
    selectAdjacent(direction) {
      const button = direction < 0 ? this.prev : this.next;
      if (button.getAttribute('aria-disabled') === 'true') return;
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const index = this.active + direction * (rtl ? -1 : 1);
      if (index < 0 || index >= this.tabs.length) return;
      this.activate(index, true);
      // Keep keyboard focus available when a boundary arrow disappears.
      if (document.activeElement === button && button.getAttribute('aria-disabled') === 'true') {
        this.tabs[index].focus({ preventScroll: true });
      }
    }
    reveal(tab, smooth) {
      if (!tab) return;
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      if (maxScroll <= 1) return;
      const view = this.viewport.getBoundingClientRect();
      const rect = tab.getBoundingClientRect();
      // Center the selected tab in the fixed viewport, clamping at both ends.
      // Use current rendered coordinates so repeated clicks interrupt smoothly.
      const delta = rect.left + rect.width / 2 - (view.left + view.width / 2);
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const desired = this.viewport.scrollLeft + delta;
      const target = rtl
        ? Math.max(-maxScroll, Math.min(0, desired))
        : Math.max(0, Math.min(maxScroll, desired));
      this.viewport.scrollTo({ left: target, behavior: this.behavior(smooth) });
    }
    activate(index, scroll) {
      if (!this.tabs[index] || this.active === index) return;
      const previous = this.active;
      this.active = index;
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
        panel.setAttribute('aria-hidden', String(i !== index));
        panel.inert = i !== index;
      });
      this.updateIndicator();
      this.updateArrows();
      if (scroll) this.reveal(this.tabs[index], true);
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        if (this.active !== index) return;
        const panel = this.panels[index];
        panel?.querySelectorAll('yg-swiper').forEach(el => {
          el.swiper?.update();
          // Start the newly chosen collection at its first product.
          if (scroll && el.swiper) {
            if (el.swiper.params.loop) el.swiper.slideToLoop(0, 0);
            else el.swiper.slideTo(0, 0);
          }
        });
        if (scroll && previous !== index && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const cards = [...(panel?.querySelectorAll('.swiper-slide') || [])];
          const targets = cards.length ? cards : panel ? [panel] : [];
          targets.forEach((card, i) => {
            this.animations.push(card.animate([
              { opacity: 0, transform: 'translateY(16px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 400, delay: Math.min(i, 5) * 35, easing: 'cubic-bezier(.22,.68,0,1)', fill: 'backwards' }));
          });
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["torras-flasheye-details"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('torras-flasheye-details')) {
  customElements.define('torras-flasheye-details', class extends HTMLElement {
    // This replacement removes legacy detail sections; adapt only its sibling product anchor bar.
    setupProductNavigation(signal, reduced) {
      const section = this.closest('.shopify-section');
      const container = section && section.parentElement;
      if (!container) return;
      const siblings = [...container.children];
      const navSection = siblings.find(el => el.id.endsWith('__yg_nav_PHLjHf'));
      const nav = navSection && navSection.querySelector('yg-nav');
      if (!nav || siblings.indexOf(navSection) >= siblings.indexOf(section)) return;
      const findSection = suffix => siblings.find(el => el.id.endsWith(suffix));
      const targets = new Map([
        ['Purchase', findSection('__main')],
        ['Overview', this],
        ['Reviews', findSection('__1774593592daa5784b')],
        ['FAQs', findSection('__yg_collapsible_content_EkmkaU')]
      ]);
      const anchors = [...nav.querySelectorAll('yg-anchor-item.yg-nav-tab')];
      const obsolete = new Set(['Specs', 'In the box', 'Compare']);
      anchors.forEach(anchor => {
        if (!obsolete.has(anchor.textContent.trim())) return;
        const original = anchor.getAttribute('style');
        anchor.style.setProperty('display', 'none', 'important');
        this.cleanups.push(() => original === null ? anchor.removeAttribute('style') : anchor.setAttribute('style', original));
      });
      const navigate = event => {
        const anchor = event.target.closest && event.target.closest('yg-anchor-item.yg-nav-tab');
        if (!anchor || !nav.contains(anchor)) return;
        const target = targets.get(anchor.textContent.trim());
        if (!target) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const header = document.querySelector('.shopify-section--header');
        const offset = (header ? header.getBoundingClientRect().height : 0) + (nav.querySelector('.yg-nav-top')?.getBoundingClientRect().height || 0) + 12;
        window.scrollTo({top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      nav.addEventListener('click', navigate, {capture: true, signal});
      nav.addEventListener('keydown', navigate, {capture: true, signal});
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cleanups = [];
      const signal = this.controller.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.setupProductNavigation(signal, reduced);
      this.setAttribute('data-enhanced', '');
      this.querySelectorAll('.tfd-slider').forEach(slider => this.setupSlider(slider, signal, reduced));
      const rows = [...this.querySelectorAll('.tfd-feature-row')];
      if (this.dataset.motion === 'true' && !reduced.matches) {
        const rowObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.removeAttribute('data-waiting');
            rowObserver.unobserve(entry.target);
          }
        }), {rootMargin: '0px 0px -100px 0px', threshold: .1});
        rows.forEach(row => { row.setAttribute('data-waiting', ''); rowObserver.observe(row); });
        this.cleanups.push(() => rowObserver.disconnect());
        reduced.addEventListener('change', () => {
          if (reduced.matches) rows.forEach(row => row.removeAttribute('data-waiting'));
        }, {signal});
      }
      const reveal = this.querySelector('.tfd-reveal');
      const desktop = matchMedia('(min-width: 769px)');
      let ticking = false;
      const update = () => {
        ticking = false;
        const active = desktop.matches && !reduced.matches && this.dataset.motion === 'true';
        this.toggleAttribute('data-reveal-active', active);
        const text = reveal.querySelector('.tfd-reveal-text');
        const heading = text.querySelector('h2');
        const images = reveal.querySelector('.tfd-reveal-images');
        const inner = reveal.querySelector('.tfd-reveal-inner');
        if (!active) {
          [text, heading, images, inner].forEach(el => el.removeAttribute('style'));
          return;
        }
        const rect = reveal.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height - innerHeight)));
        const drive = Math.max(0, (progress - .1) / .9);
        const imageProgress = Math.max(0, Math.min(1, (progress - .1) / .6));
        text.style.width = `${100 - 65 * drive}%`;
        text.style.textAlign = progress < .1 ? 'center' : 'left';
        heading.style.whiteSpace = drive > .05 ? 'normal' : 'nowrap';
        heading.style.fontSize = `${Math.min(47 - 3 * progress, inner.clientWidth / 26)}px`;
        inner.style.gap = `${50 * drive}px`;
        images.style.flex = progress < .1 ? '0 0 0' : '1';
        images.style.opacity = String(imageProgress);
        images.style.transform = `translateX(${200 * (1 - imageProgress)}px)`;
        images.style.overflow = 'hidden';
      };
      const schedule = () => {
        if (!ticking) { ticking = true; this.frame = requestAnimationFrame(update); }
      };
      window.addEventListener('scroll', schedule, {passive: true, signal});
      window.addEventListener('resize', schedule, {passive: true, signal});
      reduced.addEventListener('change', schedule, {signal});
      update();
    }
    setupSlider(slider, signal, reduced) {
      const viewport = slider.querySelector('.tfd-viewport');
      const track = slider.querySelector('.tfd-track');
      const panels = [...track.children];
      const mode = slider.dataset.mode;
      const prev = slider.querySelector('.tfd-prev');
      const next = slider.querySelector('.tfd-next');
      const dots = [...slider.querySelectorAll('.tfd-dot')];
      const pause = slider.querySelector('.tfd-pause');
      let index = 0, timer, inView = false, paused = false, hovered = false, focused = false, pointer = null;
      const full = () => mode === 'premium' && innerWidth >= 1024 ? Math.max(1, Math.floor((viewport.clientWidth + 24) / 481)) : 1;
      const limit = () => panels.length - full();
      const gap = () => parseFloat(getComputedStyle(track).gap) || 0;
      const step = () => panels[0].getBoundingClientRect().width + gap();
      const max = () => Math.max(0, panels.length * panels[0].getBoundingClientRect().width + (panels.length - 1) * gap() - viewport.clientWidth);
      const offset = () => Math.min(index * step(), max());
      const stop = () => { clearTimeout(timer); slider.removeAttribute('data-playing'); };
      const autoplay = () => this.dataset.autoplay === 'true' && !reduced.matches && inView && !paused && !hovered && !focused && !document.hidden && (mode === 'highlights' || mode === 'premium' && innerWidth < 1024);
      const start = () => {
        stop();
        if (!autoplay() || mode === 'premium' && offset() >= max() - 1) return;
        slider.setAttribute('data-playing', '');
        timer = setTimeout(() => go(index + 1), 4000);
      };
      const draw = () => {
        index = Math.min(index, limit());
        track.style.transform = `translateX(${-offset()}px)`;
        if (prev) prev.disabled = mode === 'premium' && index === 0;
        if (next) next.disabled = mode === 'premium' && offset() >= max() - 1;
        dots.forEach((dot, n) => dot.setAttribute('aria-current', String(n === index)));
      };
      const go = n => {
        index = mode === 'premium' ? Math.max(0, Math.min(n, limit())) : (n + panels.length) % panels.length;
        draw(); start();
      };
      prev?.addEventListener('click', () => go(index - 1), {signal});
      next?.addEventListener('click', () => go(index + 1), {signal});
      dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.index)), {signal}));
      pause?.addEventListener('click', () => { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); start(); }, {signal});
      viewport.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, {signal});
      viewport.addEventListener('pointerdown', event => {
        if (event.target.closest('button') || event.pointerType === 'mouse' && event.button !== 0) return;
        pointer = {x: event.clientX, y: event.clientY, id: event.pointerId, offset: offset(), horizontal: false};
        stop();
      }, {signal});
      viewport.addEventListener('pointermove', event => {
        if (!pointer) return;
        const x = event.clientX - pointer.x, y = event.clientY - pointer.y;
        if (Math.abs(x) > 8 && Math.abs(x) > Math.abs(y)) {
          pointer.horizontal = true;
          viewport.setPointerCapture(event.pointerId);
          track.setAttribute('data-dragging', '');
          track.style.transform = `translateX(${Math.min(0, Math.max(-max(), -pointer.offset + x))}px)`;
          event.preventDefault();
        }
      }, {signal});
      const up = event => {
        if (!pointer) return;
        const x = event.clientX - pointer.x;
        const horizontal = pointer.horizontal;
        pointer = null;
        track.removeAttribute('data-dragging');
        if (horizontal && Math.abs(x) > Math.min(step() * .25, 80)) go(index + (x < 0 ? 1 : -1));
        else { draw(); start(); }
      };
      viewport.addEventListener('pointerup', up, {signal});
      viewport.addEventListener('pointercancel', () => { pointer = null; track.removeAttribute('data-dragging'); draw(); start(); }, {signal});
      slider.addEventListener('pointerdown', () => { focused = false; }, {signal});
      slider.addEventListener('focusin', event => { focused = event.target.matches(':focus-visible'); if (focused) stop(); else start(); }, {signal});
      slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) { focused = false; start(); } }, {signal});
      viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } }, {signal});
      viewport.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; start(); } }, {signal});
      document.addEventListener('visibilitychange', start, {signal});
      reduced.addEventListener('change', start, {signal});
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
        start();
      }, {threshold: [0, .3]});
      observer.observe(viewport);
      const resize = new ResizeObserver(() => { draw(); start(); });
      resize.observe(viewport);
      this.cleanups.push(() => { stop(); observer.disconnect(); resize.disconnect(); });
      draw();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.cleanups?.forEach(cleanup => cleanup());
      cancelAnimationFrame(this.frame);
      this.controller = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-awards-box-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initSection(section) {
      if (!section || section.dataset.awardsV2Ready === 'true') {
        return;
      }

      const card = section.querySelector('[data-awards-card]');
      const button = section.querySelector('[data-show-more-btn]');
      const wrap = section.querySelector('[data-show-more-wrap]');

      if (!card || !button || !wrap) {
        section.dataset.awardsV2Ready = 'true';
        return;
      }

      const items = card.querySelectorAll('.award-item');
      if (items.length <= 6) {
        wrap.style.display = 'none';
      }

      button.addEventListener('click', () => {
        card.classList.add('is-expanded');
        wrap.style.display = 'none';
      });

      section.dataset.awardsV2Ready = 'true';
    }

    function initAll() {
      document.querySelectorAll('[data-awards-v2-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collapse-text"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-collapsible-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('details-accordion')) {
    customElements.define(
      'details-accordion',
      class DetailsAccordion extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          this.el = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.content = this.summary.nextElementSibling;

          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;

          if (!this.dataset.ignoreSetupEvent) {
            this.setupEventListener();
          }
        }

        setupEventListener() {
          this.onClickSummaryHandler = this.onClick.bind(this);
          this.summary.addEventListener('click', this.onClickSummaryHandler);
        }

        onClick(e) {
          e.preventDefault();
          this.toggleContent();
        }

        toggleContent() {
          this.el.style.overflow = 'hidden';
          if (this.isClosing || !this.el.open) {
            this.open();
          } else if (this.isExpanding || this.el.open) {
            this.shrink();
          }
          if (this.dataset.ignoreSetupEvent) {
            return false;
          }
        }

        disconnectedCallback() {
          this.summary.removeEventListener('click', this.onClickSummaryHandler);
        }

        shrink() {
          if (this.dataset.ignoreSetupEvent) {
            this.querySelector('summary').setAttribute('aria-expanded', false);
          } else {
            this.summary.setAttribute('aria-expanded', false);
          }
          this.isClosing = true;

          const startHeight = `${this.el.offsetHeight}px`;
          let endHeight;
          if (this.dataset.ignoreSetupEvent) {
            endHeight = `${this.querySelector('summary').offsetHeight}px`;
          } else {
            endHeight = `${this.summary.offsetHeight}px`;
          }

          if (this.animation) {
            this.animation.cancel();
          }
          this.animation = this.el.animate(
            {
              height: [startHeight, endHeight],
            },
            {
              duration: 400,
              easing: 'ease-out',
            }
          );

          this.animation.onfinish = () => this.onAnimationFinish(false);
          this.animation.oncancel = () => (this.isClosing = false);
        }

        open() {
          this.el.style.height = `${this.el.offsetHeight}px`;
          this.el.open = true;
          window.requestAnimationFrame(() => this.expand());
        }

        expand() {
          this.isExpanding = true;
          const startHeight = `${this.el.offsetHeight}px`;
          let endHeight;
          if (this.dataset.ignoreSetupEvent) {
            this.querySelector('summary').setAttribute('aria-expanded', true);
            endHeight = `${
              this.querySelector('summary').offsetHeight + this.querySelector('summary').nextElementSibling.offsetHeight
            }px`;
          } else {
            this.summary.setAttribute('aria-expanded', true);
            endHeight = `${this.summary.offsetHeight + this.summary.nextElementSibling.offsetHeight}px`;
          }

          if (this.animation) {
            this.animation.cancel();
          }

          this.animation = this.el.animate(
            {
              height: [startHeight, endHeight],
            },
            {
              duration: 400,
              easing: 'ease-out',
            }
          );
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => (this.isExpanding = false);
        }

        onAnimationFinish(open) {
          this.el.open = open;
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.el.style.height = this.el.style.overflow = '';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-grid-with-m-swiper"] && !Shopify.designMode) return;
  try {
    
  const button = document.getElementById('yg-custom-button-join-us');
  if (button) {
    button.addEventListener('click', (event) => {
      const smileUI = window.SmileUI;
      if (smileUI && typeof smileUI.openPanel === 'function') {
        smileUI.openPanel(button);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-swiper"] && !Shopify.designMode) return;
  try {
    
  class YGMediaSwiper extends (typeof YGUtils === 'undefined' ? HTMLElement : YGUtils) {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.isMobileMedia = window.matchMedia('(max-width: 699px)');
      this.slides = Array.from(this.querySelectorAll('.yg-ms__slide'));
      this.setIndicatorAreaByViewport();
      this.hoverTabs = false;
      this.pausedByUser = false;
      this.timerDuration = 0;
      this.remainingDuration = 0;
      this.tickId = null;
      this.startStamp = 0;

      const swiperEl = this.querySelector('.yg-ms__swiper');
      if (!swiperEl || this.slides.length <= 1 || typeof Swiper === 'undefined') {
        this.bindEvents();
        this.onSlideChanged();
        this.updateIndicatorMode();
        return;
      }

      const enableTransitionAnimation = this.dataset.transitionAnimation === 'true';

      this.swiper = new Swiper(swiperEl, {
        loop: this.dataset.loop === 'true',
        speed: enableTransitionAnimation ? 450 : 0,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: 1,
        on: {
          init: () => {
            this.bindEvents();
            this.onSlideChanged();
          },
          slideChange: () => this.onSlideChanged(),
        },
      });
    }

    disconnectedCallback() {
      this.stopTimer(true);
    }

    bindEvents() {
      this.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const dotButton = target.closest('[data-dot-index]');
        if (dotButton && this.contains(dotButton)) {
          this.slideTo(dotButton.getAttribute('data-dot-index'));
          return;
        }

        const tabButton = target.closest('[data-tab-index]');
        if (tabButton && this.contains(tabButton)) {
          this.slideTo(tabButton.getAttribute('data-tab-index'));
          return;
        }

        const playPauseButton = target.closest('[data-play-pause]');
        if (playPauseButton && this.contains(playPauseButton)) {
          event.stopPropagation();
          this.togglePlaybackByUser();
        }
      });

      this.indicatorArea?.addEventListener('mouseenter', () => {
        this.hoverTabs = true;
        this.updateIndicatorMode();
      });

      this.indicatorArea?.addEventListener('mouseleave', () => {
        this.hoverTabs = false;
        this.updateIndicatorMode();
      });

      this.slides.forEach((slide) => {
        if (!this.isVideoSlide(slide)) return;

        const toggle = slide.querySelector('[data-media-toggle]');
        const media = slide.querySelector('.yg-ms__media');

        toggle?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.togglePlaybackByUser();
        });

        media?.addEventListener('click', () => {
          if (slide !== this.activeSlide) return;
          this.togglePlaybackByUser();
        });
      });

      this.isMobileMedia.addEventListener('change', () => {
        this.setIndicatorAreaByViewport();
        this.mountIndicatorToActiveSlide();
        this.updateActiveButtons();
        this.updatePlayPauseUI();
        this.updateIndicatorMode();
      });
      window.addEventListener('resize', () => {
        this.setIndicatorAreaByViewport();
        this.syncExpandedThumb();
      });
    }

    slideTo(index) {
      if (!this.swiper) return;
      this.swiper.slideToLoop(parseInt(index, 10));
    }

    get activeIndex() {
      if (!this.swiper) return 0;
      return this.swiper.realIndex ?? 0;
    }

    get activeSlide() {
      return this.slides[this.activeIndex];
    }

    setIndicatorAreaByViewport() {
      const indicatorSelector = this.isMobileMedia.matches
        ? '[data-indicator-area].hide-pc'
        : '[data-indicator-area].hide-mobile';

      this.indicatorArea = this.querySelector(indicatorSelector) || this.querySelector('[data-indicator-area]');
      this.playPauseButton = this.indicatorArea?.querySelector('[data-play-pause]') || null;
      this.expandedThumb = this.indicatorArea?.querySelector('[data-expanded-thumb]') || null;
      this.leftCapsule = this.indicatorArea?.querySelector('.yg-ms__left-capsule') || null;
      this.tabsInner = this.indicatorArea?.querySelector('.yg-ms__tabs-inner') || null;
      this.dotButtons = Array.from(this.indicatorArea?.querySelectorAll('[data-dot-index]') || []);
      this.tabButtons = Array.from(this.indicatorArea?.querySelectorAll('[data-tab-index]') || []);
    }

    isVideoSlide(slide) {
      return slide?.dataset.slideType === 'video';
    }

    togglePlaybackByUser() {
      this.pausedByUser = !this.pausedByUser;
      this.updatePlayPauseUI();
      this.applyPlaybackState();
    }

    getActiveVideoComponent(slide) {
      if (!slide) return null;
      return slide.querySelector('.yg-ms__snippet-video');
    }

    getActiveNativeVideo(slide) {
      const videoComponent = this.getActiveVideoComponent(slide);
      if (!videoComponent) return null;

      const videos = Array.from(videoComponent.querySelectorAll('video.yg-video-iframe'));
      return videos.find((video) => video.offsetParent !== null) || videos[0] || null;
    }

    updateIndicatorMode() {
      if (this.isMobileMedia.matches) {
        this.dataset.indicatorState = 'tabs';
        return;
      }

      if (!this.isVideoSlide(this.activeSlide)) {
        this.dataset.indicatorState = 'tabs';
        return;
      }

      if (this.pausedByUser || this.hoverTabs) {
        this.dataset.indicatorState = 'tabs';
      } else {
        this.dataset.indicatorState = 'dots';
      }
    }

    updateActiveButtons() {
      const index = this.activeIndex;
      this.dotButtons.forEach((button, dotIndex) => {
        button.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
      this.tabButtons.forEach((button, tabIndex) => {
        button.setAttribute('aria-current', tabIndex === index ? 'true' : 'false');
      });
      this.syncExpandedThumb();
    }

    syncExpandedThumb() {
      if (!this.expandedThumb) return;
      const activeTab = this.tabButtons[this.activeIndex];
      if (!activeTab) return;
      if (this.leftCapsule && this.tabsInner) {
        this.leftCapsule.style.setProperty('--yg-ms-tabs-width', `${this.tabsInner.scrollWidth + 12}px`);
      }
      this.expandedThumb.style.width = `${activeTab.offsetWidth}px`;
      this.expandedThumb.style.transform = `translateX(${activeTab.offsetLeft}px)`;
      this.centerActiveTab(activeTab);
    }

    centerActiveTab(activeTab) {
      if (!this.isMobileMedia?.matches || !this.tabsInner) return;

      const maxScroll = this.tabsInner.scrollWidth - this.tabsInner.clientWidth;
      if (maxScroll <= 0) return;

      const targetScroll = activeTab.offsetLeft - (this.tabsInner.clientWidth - activeTab.offsetWidth) / 2;
      const nextScroll = Math.max(0, Math.min(targetScroll, maxScroll));
      this.tabsInner.scrollTo({
        left: nextScroll,
        behavior: 'smooth',
      });
    }

    updatePlayPauseUI() {
      if (!this.playPauseButton) return;

      const state = this.pausedByUser ? 'paused' : 'playing';
      const label = this.pausedByUser
        ? this.playPauseButton.dataset.playLabel
        : this.playPauseButton.dataset.pauseLabel;
      this.playPauseButton.dataset.state = state;
      this.playPauseButton.setAttribute('aria-pressed', this.pausedByUser ? 'false' : 'true');
      this.playPauseButton.setAttribute('aria-label', label || '');

      const currentSlideToggle = this.activeSlide?.querySelector('[data-media-toggle]');
      if (currentSlideToggle) {
        const toggleLabel = this.pausedByUser
          ? currentSlideToggle.dataset.playLabel
          : currentSlideToggle.dataset.pauseLabel;
        currentSlideToggle.setAttribute('aria-label', toggleLabel || '');
      }
    }

    onSlideChanged() {
      const activeSlide = this.activeSlide;
      this.stopAllVideos(activeSlide);
      this.mountIndicatorToActiveSlide();
      this.updateActiveButtons();
      this.updateIndicatorMode();
      this.applyPlaybackState(true);
    }

    mountIndicatorToActiveSlide() {
      if (!this.indicatorArea) return;

      const activeSlide = this.activeSlide;
      if (!activeSlide) return;

      const mediaSlot = activeSlide.querySelector('[data-indicator-slot="media"]');
      const contentSlot = activeSlide.querySelector('[data-indicator-slot="content"]');
      const shouldUseContentSlot = this.isMobileMedia.matches && this.dataset.mobileIndicatorInMedia !== 'true';
      const nextParent = shouldUseContentSlot ? contentSlot || mediaSlot : mediaSlot || contentSlot;

      if (!nextParent || this.indicatorArea.parentElement === nextParent) return;
      nextParent.appendChild(this.indicatorArea);
    }

    stopAllVideos(exceptSlide = null) {
      this.slides.forEach((slide) => {
        if (slide === exceptSlide) return;
        this.pauseActiveVideo(slide);
      });
    }

    async getDurationForSlide(slide) {
      if (!slide) return 0;

      if (slide.dataset.slideType === 'video') {
        const videoComponent = this.getActiveVideoComponent(slide);
        if (videoComponent?.playVideo) {
          videoComponent.playVideo();
        }

        const video = this.getActiveNativeVideo(slide);
        if (!video) return 0;

        if (!Number.isFinite(video.duration) || video.duration <= 0) {
          await new Promise((resolve) => {
            video.onloadedmetadata = () => resolve();
          });
        }
        return Math.max(video.duration || 0, 1);
      }

      const speed = parseFloat(slide.dataset.autoplaySpeed || this.dataset.autoplayDefault || '5');
      return Math.max(speed, 1);
    }

    applyPlaybackState(restart = false) {
      const slide = this.activeSlide;
      if (!slide) return;

      if (this.pausedByUser) {
        this.pauseActiveVideo(slide);
        this.pauseTimer();
        this.updateIndicatorMode();
        return;
      }

      this.playActiveVideo(slide, restart);
      this.resumeOrStartTimer(slide, restart);
      this.updateIndicatorMode();
    }

    async resumeOrStartTimer(slide, restart) {
      const duration = await this.getDurationForSlide(slide);
      if (duration <= 0) return;

      if (restart || !this.timerDuration || this.remainingDuration <= 0) {
        this.startTimer(duration);
      } else {
        this.resumeTimer();
      }
    }

    playActiveVideo(slide, restart) {
      if (slide.dataset.slideType !== 'video') return;
      const videoComponent = this.getActiveVideoComponent(slide);
      if (videoComponent?.playVideo) {
        videoComponent.playVideo();
      }

      const video = this.getActiveNativeVideo(slide);
      if (!video) return;

      if (restart) {
        video.currentTime = 0;
      }
      video.play().catch(() => {});
    }

    pauseActiveVideo(slide) {
      if (slide.dataset.slideType !== 'video') return;
      const videoComponent = this.getActiveVideoComponent(slide);
      if (videoComponent?.pauseVideo) {
        videoComponent.pauseVideo();
        return;
      }

      const video = this.getActiveNativeVideo(slide);
      if (video) video.pause();
    }

    startTimer(durationInSeconds) {
      this.stopTimer(true);
      this.timerDuration = durationInSeconds * 1000;
      this.remainingDuration = this.timerDuration;
      this.startStamp = performance.now();
      this.tick();
    }

    resumeTimer() {
      if (this.tickId || this.remainingDuration <= 0) return;
      this.startStamp = performance.now();
      this.tick();
    }

    pauseTimer() {
      if (!this.tickId) return;
      const elapsed = performance.now() - this.startStamp;
      this.remainingDuration = Math.max(this.remainingDuration - elapsed, 0);
      cancelAnimationFrame(this.tickId);
      this.tickId = null;
    }

    stopTimer(resetProgress) {
      if (this.tickId) {
        cancelAnimationFrame(this.tickId);
        this.tickId = null;
      }
      if (resetProgress) {
        this.timerDuration = 0;
        this.remainingDuration = 0;
        this.updateProgress(0);
      }
    }

    tick() {
      const elapsed = performance.now() - this.startStamp;
      const consumed = this.timerDuration - this.remainingDuration + elapsed;
      const ratio = this.timerDuration > 0 ? Math.min(consumed / this.timerDuration, 1) : 0;
      this.updateProgress(ratio);

      if (elapsed >= this.remainingDuration) {
        this.remainingDuration = 0;
        this.tickId = null;
        this.updateProgress(1);
        if (this.swiper && !this.pausedByUser) {
          this.swiper.slideNext();
        }
        return;
      }

      this.tickId = requestAnimationFrame(() => this.tick());
    }

    updateProgress(ratio) {
      const progress = Math.max(0, Math.min(ratio, 1));

      this.dotButtons.forEach((button, idx) => {
        const circle = button.querySelector('[data-progress-bar]');
        if (!circle) return;
        const circumference = circle.getTotalLength();

        if (idx !== this.activeIndex) {
          circle.style.strokeDasharray = `0 ${circumference}`;
          return;
        }

        circle.style.strokeDasharray = `${circumference * progress} ${circumference}`;
      });

      const playRing = this.playPauseButton?.querySelector('[data-play-progress-ring]');
      if (!playRing) return;
      const playRingCircumference = playRing.getTotalLength();
      playRing.style.strokeDasharray = `${playRingCircumference * progress} ${playRingCircumference}`;
    }
  }

  if (!window.customElements.get('yg-media-swiper')) {
    window.customElements.define('yg-media-swiper', YGMediaSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGNav extends YGUtils {
      #sectionsEl;

      constructor() {
        super();
        this.observer = null;
        this.footerObserver = null;
        this.isFooterNear = false;
        this.isAtcVisible = false;
        this.hasPassedAtc = false;
        this.boundOnVariantChange = this.onVariantChange.bind(this);
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnScroll = this.onScroll.bind(this);
        this.boundOnDocumentClick = this.onDocumentClick.bind(this);
        this.boundOnBundleInteract = this.onBundleInteract.bind(this);
        this.boundOnKachingEvent = this.onKachingEvent.bind(this);
        this.boundOnCartSettle = this.onCartSettle.bind(this);
        this.priceObserver = null;
        this.priceSyncFrame = null;
        this.lastKachingPrices = null;
        this.loadingTimer = null;
        this.loadingButton = null;
        this.kachingEventNames = ['deal-bar-selected', 'variant-selected', 'variants-changed'];
      }

      getBuyButtonsEl() {
        return (
          document.querySelector('.yg-product-info__buy-buttons') ||
          document.querySelector('.product-info__buy-buttons') ||
          document.querySelector('product-info buy-buttons') ||
          document.querySelector('product-rerender buy-buttons') ||
          document.querySelector('product-info [is="product-form"]') ||
          document.querySelector('product-rerender [is="product-form"]')
        );
      }

      updateBuyButtonsState() {
        const buyButtonsEl = this.getBuyButtonsEl();
        if (!buyButtonsEl) return;

        const rect = buyButtonsEl.getBoundingClientRect();
        this.isAtcVisible = rect.top < window.innerHeight && rect.bottom > 0;
        this.hasPassedAtc = rect.bottom <= 0;
      }

      get $sectionsEl() {
        if (this.#sectionsEl) return this.#sectionsEl;
        this.#sectionsEl = {
          atcForm:
            document.querySelector('product-info [is="product-form"]') ||
            document.querySelector('product-rerender [is="product-form"]'),
          sectionEl: this.closest('.shopify-section'),
          topBar: this.querySelector('.yg-nav-top'),
          bottomBar: this.querySelector('.yg-nav-bottom'),
          footerEl: document.querySelector('.shopify-section--footer') || document.querySelector('footer'),
        };
        return this.#sectionsEl;
      }

      connectedCallback() {
        this.observeAtcForm();
        this.observeFooter();
        this.observeProductPrice();
        this.syncVisibilityState();
        this.syncPriceFromProduct();
        document.addEventListener('variant:change', this.boundOnVariantChange);
        this.addEventListener('click', this.boundOnClick);
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        document.addEventListener('click', this.boundOnDocumentClick);
        document.addEventListener('cart:change', this.boundOnCartSettle);
        document.addEventListener('cart:error', this.boundOnCartSettle);
        document.addEventListener('variant:add', this.boundOnCartSettle);
        document.addEventListener('click', this.boundOnBundleInteract, true);
        this.kachingEventNames.forEach((eventName) => {
          document.addEventListener(eventName, this.boundOnKachingEvent, true);
        });
        window.setTimeout(() => {
          this.observeProductPrice();
          this.bindKachingEvents();
          this.syncPriceFromProduct();
        }, 600);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        if (this.footerObserver) {
          this.footerObserver.disconnect();
        }
        if (this.priceObserver) {
          this.priceObserver.disconnect();
        }
        if (this.priceSyncFrame) {
          window.cancelAnimationFrame(this.priceSyncFrame);
          this.priceSyncFrame = null;
        }
        document.removeEventListener('variant:change', this.boundOnVariantChange);
        this.removeEventListener('click', this.boundOnClick);
        window.removeEventListener('scroll', this.boundOnScroll);
        document.removeEventListener('click', this.boundOnDocumentClick);
        document.removeEventListener('cart:change', this.boundOnCartSettle);
        document.removeEventListener('cart:error', this.boundOnCartSettle);
        document.removeEventListener('variant:add', this.boundOnCartSettle);
        this.clearButtonLoadingTimer();
        document.removeEventListener('click', this.boundOnBundleInteract, true);
        this.kachingEventNames.forEach((eventName) => {
          document.removeEventListener(eventName, this.boundOnKachingEvent, true);
        });
        this.unbindKachingEvents();
      }

      setActiveState() {
        const showTopBar = this.hasPassedAtc;
        const showBottomBar = !this.isFooterNear && !this.isAtcVisible;

        if (showTopBar) {
          this.$sectionsEl.sectionEl?.classList.add('active');
          this.$sectionsEl.topBar?.classList.add('active');
        } else {
          this.$sectionsEl.sectionEl?.classList.remove('active');
          this.$sectionsEl.topBar?.classList.remove('active');
        }

        if (showBottomBar) {
          this.$sectionsEl.bottomBar?.classList.add('active');
          this.$sectionsEl.bottomBar?.classList.remove('footer-hidden');
        } else {
          this.$sectionsEl.bottomBar?.classList.remove('active');
          this.$sectionsEl.bottomBar?.classList.toggle('footer-hidden', this.isFooterNear);
        }
      }

      syncVisibilityState() {
        this.updateBuyButtonsState();
        this.setActiveState();
      }

      onScroll() {
        this.syncVisibilityState();
      }

      onDocumentClick(event) {
        const openedDetails = this.querySelector('.yg-nav-variant-dropdown[open]');
        if (!openedDetails) return;

        const isClickInsideDropdown = event.target.closest('.yg-nav-variant-dropdown');
        if (!isClickInsideDropdown) {
          openedDetails.removeAttribute('open');
        }
      }

      observeAtcForm() {
        const buyButtonsEl = this.getBuyButtonsEl();
        if (!buyButtonsEl || !this.$sectionsEl.bottomBar) return;
        if (this.observer) this.observer.disconnect();

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isAtcVisible = entry.isIntersecting;
              this.hasPassedAtc = entry.boundingClientRect.bottom <= 0;
            });
            this.setActiveState();
          },
          {
            root: null,
            threshold: 0,
          }
        );

        this.observer.observe(buyButtonsEl);
      }

      observeFooter() {
        const footerEl = this.$sectionsEl.footerEl;
        if (!footerEl || !this.$sectionsEl.bottomBar) return;
        if (this.footerObserver) this.footerObserver.disconnect();

        this.footerObserver = new IntersectionObserver(
          (entries) => {
            this.isFooterNear = entries.some((entry) => entry.isIntersecting);
            this.syncVisibilityState();
          },
          {
            root: null,
            rootMargin: '0px 0px 160px 0px',
            threshold: 0,
          }
        );

        this.footerObserver.observe(footerEl);
      }

      onVariantChange(event) {
        const formReference = event.detail?.formId;
        const formId =
          typeof formReference === 'string' ? formReference : formReference?.form?.getAttribute?.('id') || '';
        if (formId.startsWith('quick-buy-form-')) return;

        this.#sectionsEl = null;
        this.observeAtcForm();
        this.observeFooter();
        this.syncVisibilityState();

        this.getLatestDom((html) => {
          const sectionEl = this.closest('.shopify-section');
          if (!sectionEl) return;
          const latestBar = html.querySelector(`#${sectionEl.id} .yg-nav-bottom`);
          const currentBar = this.querySelector('.yg-nav-bottom');
          if (latestBar && currentBar) {
            currentBar.replaceWith(latestBar.cloneNode(true));
            this.#sectionsEl = null;
            this.observeAtcForm();
            this.observeFooter();
            this.observeProductPrice();
            this.syncVisibilityState();
            this.syncPriceFromProduct();
          }
        });
      }

      getProductPriceRoot() {
        return document.querySelector('.product-info__price') || document.querySelector('product-info .price-list');
      }

      getBundleRoots() {
        return Array.from(
          document.querySelectorAll('kaching-bundles-block, kaching-bundle, kaching-bundles, .kaching-bundles')
        );
      }

      getSearchRoots(element) {
        if (!element) return [];
        return element.shadowRoot ? [element, element.shadowRoot] : [element];
      }

      queryInRoots(roots, selector) {
        for (const root of roots) {
          const match = root.querySelector?.(selector);
          if (match) return match;
        }
        return null;
      }

      bindKachingEvents() {
        this.unbindKachingEvents();
        this.boundKachingHosts = this.getBundleRoots();
        this.boundKachingHosts.forEach((host) => {
          this.kachingEventNames.forEach((eventName) => {
            host.addEventListener(eventName, this.boundOnKachingEvent);
          });
        });
      }

      unbindKachingEvents() {
        (this.boundKachingHosts || []).forEach((host) => {
          this.kachingEventNames.forEach((eventName) => {
            host.removeEventListener(eventName, this.boundOnKachingEvent);
          });
        });
        this.boundKachingHosts = [];
      }

      onKachingEvent(event) {
        this.captureKachingItems(event.detail || {});
      }

      captureKachingItems(detail) {
        if (!detail) return;
        const items = [];
        const seen = new Set();
        const push = (entry) => {
          const id = entry?.variantId ?? entry?.id;
          const quantity = Number(entry?.quantity) || 1;
          if (!id || seen.has(String(id))) return;
          seen.add(String(id));
          items.push({ id: Number(id) || id, quantity });
        };
        (detail.variantIdQuantities || []).forEach(push);
        (detail.bundleProducts || []).forEach(push);
        (detail.upsells || []).forEach(push);
        (detail.freeGifts || []).forEach(push);
        if (!items.length) return;
        window.__ygKachingState = {
          items,
          prices: window.__ygKachingState?.prices || null,
        };
      }

      normalizePriceText(value) {
        if (value == null || value === '') return '';
        if (typeof value === 'number') return this.formatMoney(Math.round(value * 100));
        const text = String(value).trim();
        return this.parseMoneyToCents(text) == null ? '' : text;
      }

      getSelectedBundleBar() {
        for (const host of this.getBundleRoots()) {
          for (const root of this.getSearchRoots(host)) {
            const selected =
              this.queryInRoots([root], '.kaching-bundles__bar--selected') ||
              this.queryInRoots([root], '.kaching-bundles__bar[aria-checked="true"]') ||
              this.queryInRoots([root], '.kaching-bundles__bar[aria-selected="true"]') ||
              this.queryInRoots([root], '.kaching-bundles__bar:has(input:checked)') ||
              this.queryInRoots([root], '[class*="bar--selected"]');
            if (selected) return selected;
          }
        }
        return null;
      }

      getPricesFromBundleBar(bar) {
        if (!bar) return null;
        const saleEl =
          bar.querySelector('.kaching-bundles__bar-price') ||
          bar.querySelector('[class*="bar-price"]:not([class*="full-price"]):not([class*="unit-price"])');
        const compareEl =
          bar.querySelector('.kaching-bundles__bar-full-price') || bar.querySelector('[class*="full-price"]');
        const sale = this.getVisiblePriceText(saleEl);
        const compare = this.getVisiblePriceText(compareEl);
        if (!sale) return null;
        return { sale, compare };
      }

      getSelectedBundlePrices() {
        const fromBar = this.getPricesFromBundleBar(this.getSelectedBundleBar());
        if (fromBar?.sale) return fromBar;
        if (this.lastKachingPrices?.sale) return this.lastKachingPrices;
        return null;
      }

      onBundleInteract(event) {
        if (
          !event.target.closest(
            'kaching-bundle, kaching-bundles, kaching-bundles-block, .kaching-bundles, .kaching-bundles__bar'
          )
        ) {
          return;
        }
        this.bindKachingEvents();
      }

      getVisiblePriceText(element) {
        if (!element) return '';
        return Array.from(element.childNodes)
          .filter((node) => {
            if (node.nodeType === Node.TEXT_NODE) return true;
            if (node.nodeType !== Node.ELEMENT_NODE) return false;
            return !node.classList.contains('sr-only');
          })
          .map((node) => node.textContent)
          .join('')
          .replace(/\s+/g, ' ')
          .trim();
      }

      parseMoneyToCents(text) {
        if (!text) return null;
        const numeric = String(text)
          .replace(/[^\d.,-]/g, '')
          .trim();
        if (!numeric) return null;
        let normalized = numeric;
        const lastComma = numeric.lastIndexOf(',');
        const lastDot = numeric.lastIndexOf('.');
        if (lastComma > -1 && lastDot > -1) {
          normalized = lastComma > lastDot ? numeric.replace(/\./g, '').replace(',', '.') : numeric.replace(/,/g, '');
        } else if (lastComma > -1) {
          const decimals = numeric.length - lastComma - 1;
          normalized = decimals === 3 ? numeric.replace(/,/g, '') : numeric.replace(',', '.');
        }
        const amount = Number(normalized);
        if (Number.isNaN(amount)) return null;
        return Math.round(amount * 100);
      }

      formatMoney(cents) {
        const settings = window.themeVariables?.settings || {};
        const format =
          (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || '${{amount}}';
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, format);
        }
        const amount = (Math.abs(Number(cents) || 0) / 100).toFixed(2);
        return format.replace(/\{\{\s*amount(?:[^}]*)?\s*\}\}/, amount);
      }

      schedulePriceSync() {
        if (this.priceSyncFrame) return;
        this.priceSyncFrame = window.requestAnimationFrame(() => {
          this.priceSyncFrame = null;
          this.syncPriceFromProduct();
        });
      }

      observeProductPrice() {
        const priceRoot = this.getProductPriceRoot();
        if (this.priceObserver) this.priceObserver.disconnect();

        this.priceObserver = new MutationObserver(() => this.schedulePriceSync());
        if (priceRoot) {
          this.priceObserver.observe(priceRoot, {
            subtree: true,
            childList: true,
            characterData: true,
          });
        }
        this.bindKachingEvents();
      }

      syncPriceFromProduct() {
        const saleEl = this.querySelector('.yg-nav-price');
        if (!saleEl) return;

        const saleText = saleEl.getAttribute('data-yg-variant-price') || '';
        if (saleText) saleEl.textContent = saleText;

        const compareEl = this.querySelector('.yg-nav-compare-price');
        const saveEl = this.querySelector('.yg-nav-save-price');
        const compareText = compareEl?.getAttribute('data-yg-variant-price') || '';
        const saveText = saveEl?.getAttribute('data-yg-variant-price') || '';

        if (compareEl) {
          compareEl.textContent = compareText;
          compareEl.toggleAttribute('hidden', !compareText);
        }

        if (saveEl) {
          saveEl.textContent = saveText;
          saveEl.toggleAttribute('hidden', !saveText);
        }
      }

      clearButtonLoadingTimer() {
        if (!this.loadingTimer) return;
        window.clearTimeout(this.loadingTimer);
        this.loadingTimer = null;
      }

      setButtonLoading(button, isLoading) {
        if (!button) return false;
        this.clearButtonLoadingTimer();

        if (isLoading) {
          if (button.getAttribute('aria-busy') === 'true') return false;
          button.setAttribute('aria-busy', 'true');
          this.loadingButton = button;
          this.loadingTimer = window.setTimeout(() => this.setButtonLoading(button, false), 8000);
          return true;
        }

        button.removeAttribute('aria-busy');
        if (this.loadingButton === button) this.loadingButton = null;
        return true;
      }

      onCartSettle() {
        if (!this.loadingButton?.classList.contains('yg-nav-button-add')) return;
        this.setButtonLoading(this.loadingButton, false);
      }

      onClick(event) {
        const addToCart = event.target.closest('.yg-nav-button-add');
        const buyNow = event.target.closest('.yg-nav-button-buy');
        const variantOption = event.target.closest('.yg-nav-variant-option');

        if (variantOption) {
          this.selectVariant(variantOption);
          return;
        }

        if (addToCart) {
          if (addToCart.classList.contains('disabled') || addToCart.getAttribute('aria-busy') === 'true') return;
          const addToCartButton =
            document.querySelector('product-info product-form [type="submit"]') ||
            document.querySelector('product-rerender product-form [type="submit"]') ||
            document.querySelector('product-info [is="product-form"] [type="submit"]') ||
            document.querySelector('product-rerender [is="product-form"] [type="submit"]');
          if (!addToCartButton || addToCartButton.disabled) return;
          this.setButtonLoading(addToCart, true);
          addToCartButton.click();
          return;
        }

        if (buyNow) {
          if (buyNow.classList.contains('disabled') || buyNow.getAttribute('aria-busy') === 'true') return;
          const buyNowButton =
            document.querySelector('product-info [data-buy-now-trigger]') ||
            document.querySelector('product-rerender [data-buy-now-trigger]') ||
            document.querySelector('product-info .shopify-payment-button .shopify-payment-button__button') ||
            document.querySelector('product-rerender .shopify-payment-button .shopify-payment-button__button');
          if (!buyNowButton || buyNowButton.disabled) return;
          this.setButtonLoading(buyNow, true);
          buyNowButton.click();
        }
      }

      selectVariant(variantOption) {
        const selectedTitle = variantOption.getAttribute('data-variant-title');
        const selectedId = variantOption.getAttribute('data-variant-id');
        if (!selectedTitle) return;

        const optionsText = selectedTitle.split('/').map((item) => item.trim());
        const forms = document.querySelectorAll('.variant-picker fieldset.variant-picker__option');
        let isSelectedFromLabels = false;

        if (forms.length > 0) {
          forms.forEach((form) => {
            const labels = form.querySelectorAll('label');
            labels.forEach((label) => {
              optionsText.forEach((text) => {
                const span = label.querySelector('span');
                if (span && span.innerText === text) {
                  label.click();
                  isSelectedFromLabels = true;
                }
              });
            });
          });
        }

        if (!isSelectedFromLabels && selectedId) {
          const idInput =
            document.querySelector('product-info [is="product-form"] [name="id"]') ||
            document.querySelector('product-rerender [is="product-form"] [name="id"]');
          if (idInput) {
            idInput.value = selectedId;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        const currentTitle = this.querySelector('.yg-nav-variant-current');
        if (currentTitle) {
          currentTitle.textContent = selectedTitle;
        }

        this.querySelectorAll('.yg-nav-variant-option').forEach((item) => {
          item.classList.toggle('active', item === variantOption);
        });

        const details = variantOption.closest('.yg-nav-variant-dropdown');
        if (details) {
          details.removeAttribute('open');
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });

        setTimeout(() => {
          this.syncVisibilityState();
        }, 420);
      }
    }

    if (!window.customElements.get('yg-nav')) {
      window.customElements.define('yg-nav', YGNav);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGIimelineSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        // 初始化图片 swiper
        this.imagesSwiperEl = this.querySelector('.yg-timeline-images-swiper');
        this.contentSwiperEl = this.querySelector('.yg-timeline-swiper');
        this.prevBtn = this.querySelector('.swiper-button-prev');
        this.nextBtn = this.querySelector('.swiper-button-next');

        // 创建图片 swiper 实例
        this.imagesSwiperInstance = new Swiper(this.imagesSwiperEl, {
          spaceBetween: 0,
          slidesPerView: 1,
          effect: 'fade',
        });

        // 创建内容 swiper 实例
        this.contentSwiperInstance = new Swiper(this.contentSwiperEl, {
          spaceBetween: 12,
          slidesPerView: 1,
          breakpoints: {
            700: {
              slidesPerView: 1,
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn,
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
          controller: {
            control: this.imagesSwiperInstance,
          },
        });

        // 设置双向控制
        this.imagesSwiperInstance.controller.control = this.contentSwiperInstance;
      }
    }

    if (!customElements.get('yg-timeline-swiper')) {
      customElements.define('yg-timeline-swiper', YGIimelineSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGVideoList01 extends HTMLElement {
      constructor() {
        super();
        this.playbackMode = this.getAttribute('data-playback-mode');
        this.isMobile = window.innerWidth <= 1024;
      }

      connectedCallback() {
        this.slideItems = this.querySelectorAll('.yg-slide-item');
        this.initSoundToggle();
        if (this.playbackMode === 'hover') {
          if (!this.isMobile) {
            this.initHoverPlayback();
          } else {
            this.initMobilePlaybackWhenVisible();
          }
        }
      }

      initSoundToggle() {
        this.slideItems.forEach((item) => {
          const btn = item.querySelector('.yg-video-sound-toggle');
          if (!btn) return;

          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const videoEl = item.querySelector('yg-video');
            if (!videoEl) return;

            this.ensureVideoReady(videoEl);

            const videos = videoEl.querySelectorAll('video.yg-video-iframe');
            const isCurrentlyMuted = !btn.classList.contains('is-unmuted');

            videos.forEach((video) => {
              video.muted = !isCurrentlyMuted;
            });

            btn.classList.toggle('is-unmuted', isCurrentlyMuted);
            btn.setAttribute('aria-pressed', isCurrentlyMuted ? 'true' : 'false');
          });
        });
      }

      ensureVideoReady(videoEl) {
        const tpl = videoEl.querySelector('template');
        if (tpl && !videoEl.querySelector('.yg-video-iframe-container')) {
          videoEl.appendChild(tpl.content.cloneNode(true));
        }

        const container = videoEl.querySelector('.yg-video-iframe-container');
        if (container && !container.dataset.ygPrepared) {
          container.dataset.ygPrepared = 'true';
          container.classList.add('close');
        }

        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.autoplay = false;
          video.muted = true;
          video.preload = 'metadata';
          video.removeAttribute('autoplay');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          if (!video.dataset.ygEndedCoverBound) {
            video.dataset.ygEndedCoverBound = 'true';
            video.addEventListener('ended', () => {
              this.pauseVideo(videoEl, false, true);
            });
          }
        });

        return container;
      }

      initHoverPlayback() {
        this.slideItems.forEach((item) => {
          const videoEl = item.querySelector('yg-video');
          if (!videoEl) return;

          item.addEventListener('mouseenter', () => {
            this.playVideo(videoEl);
          });

          item.addEventListener('mouseleave', () => {
            this.pauseVideo(videoEl);
          });
        });
      }

      initMobileSwipePlayback() {
        const swiperEl = this.querySelector('yg-swiper');
        if (!swiperEl) return;

        const waitForSwiper = () => {
          if (swiperEl.swiper) {
            this.setupMobileSlideEvents(swiperEl.swiper);
          } else {
            requestAnimationFrame(waitForSwiper);
          }
        };
        waitForSwiper();
      }

      initMobilePlaybackWhenVisible() {
        if (!('IntersectionObserver' in window)) {
          this.initMobileSwipePlayback();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            this.initMobileSwipePlayback();
          },
          { rootMargin: '300px 0px' }
        );

        observer.observe(this);
      }

      setupMobileSlideEvents(swiper) {
        this.currentMobileIndex = swiper.realIndex || 0;

        const firstSlide = swiper.slides[swiper.activeIndex];
        if (firstSlide) {
          const videoEl = firstSlide.querySelector('yg-video');
          if (videoEl) this.playVideo(videoEl);
        }

        swiper.on('slideChangeTransitionStart', () => {
          const prevSlide = swiper.slides[swiper.previousIndex];
          if (prevSlide) {
            const prevVideoEl = prevSlide.querySelector('yg-video');
            if (prevVideoEl) this.pauseVideo(prevVideoEl, true);
          }
        });

        swiper.on('slideChangeTransitionEnd', () => {
          this.currentMobileIndex = swiper.realIndex;
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            const activeVideoEl = activeSlide.querySelector('yg-video');
            if (activeVideoEl) this.playVideo(activeVideoEl);
          }
        });
      }

      playVideo(videoEl) {
        const container = this.ensureVideoReady(videoEl);
        const image = videoEl.querySelector('.yg-video-placeholder');

        if (container) {
          container.classList.remove('close');
        }
        image?.classList.add('close');

        const btn = videoEl.querySelector('.yg-video-button');
        if (btn) btn.classList.add('hide');

        const slideItem = videoEl.closest('.yg-slide-item');
        const soundBtn = slideItem?.querySelector('.yg-video-sound-toggle');
        const isUnmuted = soundBtn?.classList.contains('is-unmuted') ?? false;

        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.muted = !isUnmuted;
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        });
      }

      pauseVideo(videoEl, keepFrame, resetTime = false) {
        const videos = videoEl.querySelectorAll('video.yg-video-iframe');
        videos.forEach((video) => {
          video.pause();
          if (resetTime) {
            video.currentTime = 0;
          }
        });

        if (keepFrame) return;

        const image = videoEl.querySelector('.yg-video-placeholder');
        image?.classList.remove('close');

        const btn = videoEl.querySelector('.yg-video-button');
        if (btn) btn.classList.remove('hide');
      }
    }

    if (!window.customElements.get('yg-video-list-01')) {
      window.customElements.define('yg-video-list-01', YGVideoList01);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
